import script from "./dx-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./dx-upload.vue?vue&type=script&setup=true&lang=js"

import "./dx-upload.vue?vue&type=style&index=0&id=5ca473fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca473fa"]])

export default __exports__